import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-markup-condition-group',
  templateUrl: './markup-condition-group.component.html',
  styleUrls: ['./markup-condition-group.component.scss'],
  standalone: false,
})
export class MarkupConditionGroupComponent {
  @Input()
  label: string;
  @Input()
  items: string[];
}
